export const DEFUALT_LOCALE = 'en-US';

export const SUPPORTED_LOCALES = ['en-US', 'fr-CA'] as const;

export const SUPPORTED_CUSTOM_NAMESPACES = [
  'categories',
  'kds_custom_fields',
] as const;

export const RTL_LOCALES: SupportedLocale[] = [];

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export type SupportedNamespace = (typeof SUPPORTED_CUSTOM_NAMESPACES)[number];

export function isSupportedLocale(locale: string): locale is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale);
}

export function isSupportedCustomNamespace(
  namespace: string,
): namespace is SupportedNamespace {
  return (SUPPORTED_CUSTOM_NAMESPACES as readonly string[]).includes(namespace);
}
